// Filename: ContestantsGrid.js

import React from "react";
import styled from "styled-components";
import { useContext } from "react";
import { DataContext } from "../Datacontext";
import VideoCard from "../pages/VideoCard";

const GridWrapper = styled.div`
  padding: 20px;
  text-align: center;
  background-color: #f5f5f5;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const ContestantsGrid = () => {
  const { data, isLoading } = useContext(DataContext);
  //console.log("env",process.env.REACT_APP_PROJECT_NAME);
  return (
    <GridWrapper>
      <h2
        style={{
          padding: 10,
          paddingLeft: 0,
          textAlign: "left",
          color: "#5C588B",
        }}
      >
        Contestants
      </h2>
      <Grid>
        {isLoading ? (
          <div className="spinner">
            {/* Simple spinner example */}
            <div className="loader"></div>
          </div>
        ) : (
          <>
            {data.map((video, index) => (
              <VideoCard
                key={index}
                thumbnail={video.featured_image.thumbnail}
                title={video.title}
                onClick={video.onClick}
                vimeoUrl={video.video_url}
                cat={video.categories[0].name}
              />
            ))}
          </>
        )}

        {/* {isLoading ? (
          <h2>Loading...</h2>
        ) : (
          data.map((i) => (
            <StyledLink
              key={i.id}
              to={`/video/${i.video_url.split("/").pop()}`}
            >
              <Card>
                <img
                  src={i.featured_image.thumbnail}
                  alt={`kid${i}`}
                  style={{ width: "100%", borderRadius: "8px" }}
                />
                {/*<p>{i.auther}</p>*/}
        {/* <p>{i.title}</p>
              </Card>
            </StyledLink>
          ))
        )} */}
      </Grid>
    </GridWrapper>
  );
};

export default ContestantsGrid;
